import * as React from 'react';
import { ArticleParagraph2, ArticleParagraph3, useDeviceType } from '@cian/ui-kit';

import { InlineLink } from '../../InlineLink';

interface IPersonalAgreementProps {
  policyUrl: string;
}

export const PersonalAgreement: React.FC<IPersonalAgreementProps> = ({ policyUrl }) => {
  const deviceType = useDeviceType();

  const textAlign = deviceType === 'phone' ? 'center' : 'left';
  const ArticleParagraph = deviceType === 'phone' ? ArticleParagraph3 : ArticleParagraph2;

  return (
    <ArticleParagraph color="gray60_100" textAlign={textAlign}>
      Нажимая на кнопку, вы соглашаетесь на{' '}
      <InlineLink href={policyUrl} target="_blank" rel="noopener noreferrer">
        обработку
        <br />
        персональных данных
      </InlineLink>
    </ArticleParagraph>
  );
};
